"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./index.scss");
const get_date_iso_6801_1 = require("@App/helpers/get-date-iso-6801");
const MlcTooltip_1 = __importDefault(require("@Components/MlcTooltip"));
const clsx_1 = __importDefault(require("clsx"));
const StatusComponent = (props) => {
    const { status, count, withCount, big, date, dateTitle, tooltip, circleFirst } = props;
    const classNames = (0, clsx_1.default)('status-component', big && 'big', circleFirst && 'circle-first');
    const formattedStatus = status.replace(/\s+/g, '');
    const baseCircleId = `base-circle-${formattedStatus}`;
    const circleWithTooltip = tooltip ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: `circle ${formattedStatus.toLowerCase()}`, "data-tooltip-id": baseCircleId }),
        react_1.default.createElement(MlcTooltip_1.default, { id: baseCircleId, place: 'bottom', className: 'custom-tool-tip-content' },
            react_1.default.createElement("span", null, tooltip)))) : (react_1.default.createElement("div", { className: `circle ${formattedStatus.toLowerCase()}` }));
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement("div", { className: 'status-title' },
            circleFirst && circleWithTooltip,
            react_1.default.createElement("p", { className: 'small' },
                withCount && react_1.default.createElement("span", { className: 'status-count bold' }, '(' + count + ')'),
                " ",
                status),
            !circleFirst && circleWithTooltip),
        date && (react_1.default.createElement("strong", { className: 'small' },
            dateTitle,
            "\u00A0 ",
            (0, get_date_iso_6801_1.getDateFromIso)(date)))));
};
exports.default = StatusComponent;
